'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _range = require('./range.js');

var _dom = require('../utils/dom.js');

exports.default = {
  props: {
    barWidth: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 96
    },
    color: {
      type: String,
      default: '#F2F2F2'
    },
    fullColor: {
      type: String,
      default: '#1A4FB6'
    },
    setColor: {
      type: String,
      default: '#F56428'
    },
    ranges: {
      type: Array,
      default: function _default() {
        return _range.Range.Default;
      }
    },
    value: {
      type: Number,
      default: 5
    },
    gear: {
      type: Number,
      default: 1
    },
    readonly: {
      type: Boolean,
      default: true
    },
    grow: {
      type: Number,
      default: 42
    },
    swipable: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Number,
      default: 5
    },
    delay: {
      type: Number,
      default: 100
    }
  },
  model: {
    prop: 'gear',
    event: 'change'
  },
  data: function data() {
    return {
      rects: []
    };
  },

  computed: {
    gearRanges: function gearRanges() {
      return this.ranges.filter(function (x) {
        return x.gear;
      });
    },
    minGearRange: function minGearRange() {
      return this.gearRanges[0];
    },
    maxGearRange: function maxGearRange() {
      return this.gearRanges[this.gearRanges.length - 1];
    },
    gearRange: function gearRange() {
      var _this = this;

      return this.gearRanges.find(function (x) {
        return x.gear === _this.gear;
      });
    },
    trackStyle: function trackStyle() {
      var style = {
        width: this.barWidth + 'px',
        height: this.height + 'px',
        borderRadius: this.barWidth / 2 + 'px'
      };
      if (!this.readonly) {
        style.height = this.height + this.grow + 'px';
      }
      return style;
    },
    gearStyle: function gearStyle() {
      var style = {
        color: this.fullColor
      };
      return style;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.swipable && !this.readonly) {
      setTimeout(function () {
        return _this2.initRect();
      }, this.delay);
    }
  },

  methods: {
    initRect: function initRect() {
      var _this3 = this;

      var dom = weex.requireModule('dom');
      this.ranges.forEach(function (range, i) {
        if (range.gear) {
          (0, _dom.getBoundingClientRectBase)(dom, _this3.$refs['bar'][i], function (res) {
            _this3.rects.push(_extends({}, range, {
              left: res.size.left,
              dis: res.size.left + res.size.width
            }));
          });
        }
      });
    },
    isLast: function isLast(index) {
      return index >= this.ranges.length - 1;
    },
    isSet: function isSet(range) {
      return range.gear == this.gearRange.gear;
    },
    isPreserve: function isPreserve(range) {
      return range.min >= this.gearRange.max;
    },
    isWaiting: function isWaiting(range) {
      return range.min > this.value && range.max <= this.gearRange.min;
    },
    isFull: function isFull(range) {
      return range.min <= this.value;
    },
    getBarStyle: function getBarStyle(range) {
      var style = {
        width: this.barWidth + 'px',
        height: this.height + 'px',
        borderRadius: this.barWidth / 2 + 'px',
        opacity: 1
      };
      if (!this.readonly && this.isSet(range)) {
        style.height = this.height + this.grow + 'px';
      }
      if (this.isFull(range)) {
        style.backgroundColor = this.fullColor;
      }
      if (this.isWaiting(range)) {
        style.backgroundColor = this.fullColor;
        style.opacity = 0.3;
      }
      if (!this.isFull(range) && this.isSet(range)) {
        style.backgroundColor = this.setColor;
        this.readonly && (style.opacity = 0.3);
      }
      if (this.isPreserve(range)) {
        style.backgroundColor = this.color;
      }
      return style;
    },
    getAngleStyle: function getAngleStyle(range) {
      var style = {};
      if (this.isSet(range)) {
        style.backgroundColor = this.setColor;
      }
      return style;
    },
    onClick: function onClick(range) {
      if (this.readonly || !range.gear || range.min <= this.value) {
        return;
      }
      this.triggerChange(range.gear);
    },
    onTouchMove: function onTouchMove(e) {
      if (!this.swipable || this.readonly) {
        return;
      }
      var touch = e.changedTouches[0];
      var gear = this.getGearByPosition(touch.screenX);
      if (gear) {
        this.triggerChange(gear);
      }
    },
    getGearByPosition: function getGearByPosition(screenX) {
      this.sx = screenX;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.rects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var rect = _step.value;

          var left = rect.left - this.offset;
          var right = rect.dis + this.offset;
          if (screenX >= left && screenX <= right && rect.min > this.value) {
            return rect.gear;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return NaN;
    },
    triggerChange: function triggerChange(gear) {
      this.$emit('change', gear);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-gear/index.vue
// module id = 336
// module chunks = 0 1